import { render, staticRenderFns } from "./DeadlineEdit.vue?vue&type=template&id=3a38d820"
import script from "./DeadlineEdit.vue?vue&type=script&lang=js"
export * from "./DeadlineEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports